/**
 * Route for `tiered-affiliate-onboarding`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { TieredAffiliateOnboardingPage } from "../features/tiered-affiliate-onboarding/TieredAffiliateOnboardingPage";

export const tieredAffiliateOnboardingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tiered-affiliate-onboarding",
	component: TieredAffiliateOnboardingPage,
});

export default tieredAffiliateOnboardingRoute;
